module.exports = __webpack_public_path__ + "static/media/car-salesman.a3b0c893.png";